export default {
  list: [
    {"value": 1, "text": "普通"},
    {"value": 2, "text": "当座"},
    {"value": 3, "text": "定期"},
    {"value": 9, "text": "その他"},
  ],
};